import { useMediaQuery } from "react-responsive"

import { Swipe } from "~/shared/ui/kit/components/Swipe"
import { breakPoints } from "~/shared/ui/constants"
import { isIOS } from "react-device-detect"

export function SidebarSwipe({ setHideSidebar }) {
	const query = useMediaQuery({ maxWidth: breakPoints.xs })

	return query && !isIOS ? (
		<Swipe
			onSwipe={({ dirX, dirY, deltaTime, startX }) => {
				setHideSidebar((cur) => {
					if (cur && startX > window.innerWidth * 0.25) return cur

					const len = Math.sqrt(dirX * dirX + dirY * dirY)

					if (len < window.screen.width * 0.15) return cur

					if (cur) {
						if (dirX < 0) return cur
						if (deltaTime > 300) return cur
						if (
							Math.abs(
								(Math.atan2(dirY, dirX) * 180.0) / Math.PI,
							) > 45.0
						)
							return cur
						return false
					} else {
						if (dirX > 0) return cur
						if (deltaTime > 300) return cur
						if (
							Math.abs(
								(Math.atan2(dirY, dirX) * 180.0) / Math.PI,
							) < 135.0
						)
							return cur
						return true
					}
				})
			}}
		/>
	) : null
}
